//@flow
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {FullForecastBox, LiteForecastBox} from './ForecastBox/ForecastBox';
import {scroller} from 'react-scroll';
import {Element} from 'react-scroll/modules';
import Loading from '../../../../../../elements/Loading/Loading';

import style from './QuoteBox.scss';

import type {Forecast, ForecastPricesApiReq} from '../../../../QuoteStep/api';
import type {ForecastType} from './ForecastBox/ForecastBox';

type Props = {
  handleChangeMethod: ({ type: ForecastType; subtype: string }) => void;
  forecast?: Forecast;
  isLoadingForecast?: boolean;
  forecastRequest?: ForecastPricesApiReq;
  quoteMethodType?: ForecastType;
  quoteFullSubtype?: string;
  quoteLiteSubtype?: string;
  preferredImportationMethod?: string;
};

const SCROLL_OPTIONS = {
  duration: 350,
  delay: 0,
  smooth: 'easeInOutQuart',
  offset: -88,
};

export default class QuoteBox extends Component<Props> {
  //scroller.scrollTo(fieldToScroll, SCROLL_OPTIONS)

  componentDidUpdate(prevProps: Props) {
    const {isLoadingForecast} = this.props;

    /*if (prevProps.isLoadingForecast !== isLoadingForecast && !!isLoadingForecast) {
      scroller.scrollTo('quote', SCROLL_OPTIONS);
    }*/
  }
  
  shouldShowFull(): boolean {
    const {forecastRequest} = this.props;
    
    if (forecastRequest && forecastRequest.items) {
      const url = forecastRequest.items[0].url || '';
      
      // TODO: Might come back anytime soon
      // if (url.includes('www.apple.com/shop/buy-iphone/iphone-16')) {
      /*if (url.includes('www.apple.com') && url.includes('iphone-16')) {
        return false;
      }*/
    }
    
    return true;
  }

  shouldShowLite(): boolean {
    return true;
  }

  render() {
    const {
      handleChangeMethod, forecast, forecastRequest, quoteMethodType, quoteFullSubtype, quoteLiteSubtype,
      isLoadingForecast, preferredImportationMethod,
    } = this.props;
    
    const showFull = this.shouldShowFull();
    const showLite = this.shouldShowLite();

    // TODO: Might come back anytime soon
    /*const shouldShowIphone16Message = forecastRequest && forecastRequest.items ?
        forecastRequest.items[0].url.includes('iphone-16') : false;*/
    const shouldShowIphone16Message = false;

    return (
      <Element name="quote">
        <div className={style.quoteBoxWrap}>
          <h2 className={style.title}>2. Método de envío</h2>

          
          <p style={{fontSize: 16, lineHeight: '24px'}}>
            Antes de realizar tu pedido, revisa líneas arriba que la información del producto sea correcta
            para asegurar una compra satisfactoria y sin problemas.
          </p>
          
          {shouldShowIphone16Message && (
              /*<p style={{fontSize: 16, lineHeight: '24px'}}>El iPhone 15 solo estará disponible por Qempo Lite.&nbsp;
                <a href="https://youtu.be/k572ejwW3_E"
                   style={{fontSize: 16, lineHeight: '24px', color: '#1976d2'}}
                   target="_blank">Mira aquí un video sobre cómo funciona.</a>
              </p>*/
            <p style={{fontSize: 16, lineHeight: '24px'}}>
              {/*Los iPhone 16 podrán ser enviados una vez hayan sido homologados en Perú (ya en proceso). El tiempo estimado de entrega inicia a partir de esa fecha.*/}
              &nbsp;
              <a href="https://youtu.be/45M0LEcKcuE"
                 style={{fontSize: 16, lineHeight: '24px', color: '#1976d2'}}
                 target="_blank">Mira aquí un video tutorial sobre cómo comprar tu iPhone 16 por Qempo Lite.</a>
            </p>
          )}
          
          {/*shouldShowIphone16Message && (
              <p style={{
                fontSize: '16px',
                lineHeight: '24px',
                background: 'red',
                color: 'white',
                padding: '5px 7px',
                textAlign: 'center',
              }}>
                El iPhone 15 puede tomar 30/60 días adicionales por retrasos de Apple en USA
              </p>
          )}*/}

          <br/>

          <div className={style.quoteWrap}>
            {(!preferredImportationMethod || preferredImportationMethod === 'full') && showFull && (
              <Fragment>
                <FullForecastBox handleChangeMethod={handleChangeMethod}
                                 isLoadingForecast={isLoadingForecast}
                                 forecastClassic={forecast ? forecast['CLASSIC'] : undefined}
                                 forecastRequest={forecastRequest}
                                 quoteMethodType={quoteMethodType}
                                 quoteFullSubtype={quoteFullSubtype}
                />
                <br/>
              </Fragment>
            )}
            {(!preferredImportationMethod || preferredImportationMethod === 'lite') && showLite && (
              <LiteForecastBox handleChangeMethod={handleChangeMethod}
                               isLoadingForecast={isLoadingForecast}
                               forecastCouriers={forecast ? forecast['DIY'] : undefined}
                               forecastRequest={forecastRequest}
                               quoteMethodType={quoteMethodType}
                               quoteLiteSubtype={quoteLiteSubtype}
              />
            )}
          </div>
          {isLoadingForecast && (
            <div className={style.loadingWrap}>
              <Loading type="circle"
                       className={style.loading}/>
              <h3 className={style.title}>¡Estamos buscando la mejor opción de envío para tu producto!</h3>
            </div>
          )}
        </div>
      </Element>
    );
  }
}

QuoteBox.propTypes = {
  quoteMethodType: PropTypes.string,
  quoteFullSubtype: PropTypes.string,
  quoteLiteSubtype: PropTypes.string,
  handleChangeMethod: PropTypes.func.isRequired,
  forecast: PropTypes.object,
  isLoadingForecast: PropTypes.bool,
  forecastRequest: PropTypes.object,
  preferredImportationMethod: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/NewProductForm/QuoteBox/QuoteBox.jsx